import React, { useState, useEffect } from "react";
import { getCoinTransactions } from "../services/coinService";
import NavUser from "../components/NavUser";
import "./CoinTransactionHistory.css";

function CoinTransactionHistory() {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("all"); // all, earned, spent
    const [totalBalance, setTotalBalance] = useState(0);

    useEffect(() => {
        const fetchTransactions = async () => {
            const userData = localStorage.getItem("user");
            if (userData) {
                const user = JSON.parse(userData);
                const data = await getCoinTransactions(user.id);
                setTransactions(data);

                // Calculate total balance
                const balance = data.reduce((sum, t) => sum + (t.amount || 0), 0);
                setTotalBalance(balance);
            }
            setLoading(false);
        };

        fetchTransactions();
    }, []);

    const filteredTransactions = transactions.filter(t => {
        if (filter === "earned") return t.amount > 0;
        if (filter === "spent") return t.amount < 0;
        return true;
    });

    const totalEarned = transactions
        .filter(t => t.amount > 0)
        .reduce((sum, t) => sum + t.amount, 0);

    const totalSpent = Math.abs(
        transactions
            .filter(t => t.amount < 0)
            .reduce((sum, t) => sum + t.amount, 0)
    );

    if (loading) {
        return (
            <div className="coin-history-container">
                <NavUser />
                <p>Loading transactions...</p>
            </div>
        );
    }

    return (
        <div className="coin-history-container">
            <NavUser />

            <h1>Coin Transaction History</h1>

            {/* Summary Cards */}
            <div className="summary-cards">
                <div className="summary-card balance">
                    <h3>Current Balance</h3>
                    <p className="amount">🪙 {totalBalance}</p>
                </div>
                <div className="summary-card earned">
                    <h3>Total Earned</h3>
                    <p className="amount">+{totalEarned}</p>
                </div>
                <div className="summary-card spent">
                    <h3>Total Spent</h3>
                    <p className="amount">-{totalSpent}</p>
                </div>
            </div>

            {/* Filter Buttons */}
            <div className="filter-buttons">
                <button
                    className={filter === "all" ? "active" : ""}
                    onClick={() => setFilter("all")}
                >
                    All Transactions
                </button>
                <button
                    className={filter === "earned" ? "active" : ""}
                    onClick={() => setFilter("earned")}
                >
                    Earned
                </button>
                <button
                    className={filter === "spent" ? "active" : ""}
                    onClick={() => setFilter("spent")}
                >
                    Spent
                </button>
            </div>

            {/* Transactions List */}
            <div className="transactions-list">
                {filteredTransactions.length === 0 ? (
                    <p className="no-transactions">No transactions found.</p>
                ) : (
                    filteredTransactions.map((transaction, index) => (
                        <div key={index} className="transaction-item">
                            <div className="transaction-icon">
                                {transaction.amount > 0 ? "📥" : "📤"}
                            </div>
                            <div className="transaction-details">
                                <p className="transaction-description">
                                    {transaction.description || "Transaction"}
                                </p>
                                <p className="transaction-date">
                                    {new Date(transaction.created_at).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit"
                                    })}
                                </p>
                            </div>
                            <div className={`transaction-amount ${transaction.amount > 0 ? "positive" : "negative"}`}>
                                {transaction.amount > 0 ? "+" : ""}{transaction.amount}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default CoinTransactionHistory;
